import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const login = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #18182e;
  min-height: 100vh;
  width: 100vw;

  > :last-child {
    margin-bottom: 50px;
  }

  > div,
  form {
    width: 400px;
  }
`;

export const previousStep = css`
  margin-top: 20px;

  > button {
    color: ${colors.white};
    align-self: flex-start;

    :hover {
      color: ${colors.white};
      text-decoration: underline;
    }
  }
`;

export const nextStep = css`
  margin-top: 40px;
  align-self: flex-end;
  color: ${colors.white};
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  svg {
    margin-right: 5px;
  }
`;

export const logo = css`
  height: 100px;
  margin-top: 50px;

  color: ${colors.white};
`;

export const heading = css`
  color: ${colors.white};
  font-size: ${fonts.size.largest};
  margin-top: 30px;
`;

export const loading = css`
  width: 150px;
  height: 20px;
  margin-top: 30px;

  g {
    fill: ${colors.white};
  }
`;

export const form = css`
  position: relative;
  display: flex;
  flex-direction: column;

  > button {
    margin-top: 40px;
  }
`;

export const formBodyText = css`
  color: ${colors.white};
  margin-top: 20px;
  text-align: center;
`;

export const input = css`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  > div:first-child {
    color: ${colors.white};
    margin-bottom: 5px;
  }
`;

export const inputError = css`
  position: absolute;
  left: 0;
  top: calc(100% + 5px);
`;

export const passwordForm = css`
  > span {
    display: block;
    margin: 30px 0;
  }

  > form {
    > div,
    button {
      width: 100%;
    }
  }
`;
